import React from "react";

const ChitranSvg = ({ height, width }) => {
  return (
    <svg
      width={width ?? "180"}
      height={height ?? "200"}
      viewBox="0 0 183 238"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="17.0684"
        y="102.646"
        width="6.22433"
        height="102.183"
        rx="3.11216"
        fill="#FFBB56"
      />
      <rect
        x="120.288"
        y="81.3809"
        width="6.22433"
        height="120.856"
        rx="3.11216"
        fill="#FFBB56"
      />
      <path
        d="M14.4746 114.679C14.4746 111.36 16.8047 108.498 20.0543 107.824L121.723 86.7566C126.068 85.8562 130.143 89.1738 130.143 93.611V140.411C130.143 143.729 127.813 146.592 124.564 147.265L22.895 168.333C18.5501 169.233 14.4746 165.915 14.4746 161.478V114.679Z"
        fill="black"
      />
      <rect
        x="167.489"
        y="205.348"
        width="7.78041"
        height="120.856"
        rx="3.89021"
        transform="rotate(90 167.489 205.348)"
        fill="#FFBB56"
      />
      <rect
        x="182.013"
        y="155.035"
        width="7.78041"
        height="120.856"
        rx="3.89021"
        transform="rotate(90 182.013 155.035)"
        fill="#FFBB56"
      />
      <path
        d="M1.91185 171.362C7.56943 122.876 59.9595 106.736 84.7292 106.114C162.302 100.053 162.113 161.021 162.302 205.348L1.04355 205.348C1.04439 192.92 0.65901 182.098 1.91185 171.362Z"
        fill="#6C65D9"
      />
      <path
        d="M49.2266 124.432C32.835 101.244 54.6092 89.3548 68.9019 85.8883C69.7664 85.6786 70.6081 86.2665 70.7454 87.1455L71.7079 93.3055C71.7609 93.6451 71.7001 93.9926 71.5348 94.2939L63.6522 108.668C63.2665 109.372 63.4858 110.255 64.1404 110.719C97.1183 134.085 102.266 179.688 102.148 203.571C102.144 204.421 101.45 205.089 100.6 205.089H69.0415C68.1423 205.089 67.4308 204.333 67.4763 203.435C68.4434 184.324 65.7496 147.806 49.2266 124.432Z"
        fill="#A09AFB"
      />
      <path
        d="M123.659 114.319C128.124 99.4801 115.965 93.3115 107.839 91.4961L44.5582 110.428C38.5413 111.881 37.0371 118.122 37.0371 121.062C43.2614 118.572 52.2521 122.099 55.9694 124.174C86.313 141.11 114.841 143.625 123.659 114.319Z"
        fill="#A09AFB"
      />
      <path
        d="M119.471 157.004C120.281 148.186 111.202 125.304 105.745 113.143C105.428 112.437 105.967 111.647 106.741 111.68L123.625 112.397C124.007 112.413 124.349 112.638 124.515 112.982L146.304 158.122C146.511 158.55 146.403 159.069 146.017 159.346C139.464 164.051 131.04 158.796 120.6 158.356C119.918 158.327 119.408 157.684 119.471 157.004Z"
        fill="#A09AFB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M117.38 123.764C117.892 124.02 118.1 124.643 117.844 125.156C115.382 130.081 111.552 133.332 106.228 135.994C105.716 136.25 105.093 136.042 104.836 135.53C104.58 135.017 104.788 134.394 105.3 134.138C110.35 131.613 113.782 128.64 115.988 124.228C116.244 123.716 116.868 123.508 117.38 123.764Z"
        fill="#252A38"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M73.2756 121.502C73.605 121.033 74.2521 120.92 74.7208 121.249C84.5833 128.18 89.8615 139.066 93.5049 148.435C93.7125 148.969 93.448 149.57 92.914 149.778C92.38 149.985 91.7788 149.721 91.5712 149.187C87.9528 139.882 82.8571 129.502 73.5279 122.947C73.0592 122.617 72.9462 121.97 73.2756 121.502Z"
        fill="#252A38"
      />
      <path
        d="M57.2987 95.9246C67.2265 89.9679 81.7046 90.1334 87.7026 90.9607C100.94 92.6153 124.684 98.903 113.763 110.817C102.843 122.73 81.4978 118.263 72.1904 114.54C63.0899 110.816 47.3709 101.881 57.2987 95.9246Z"
        fill="#252A38"
      />
      <path
        d="M69.0883 113.3L68.4678 80.4141L103.215 91.5829L105.077 116.402C95.1488 121.366 76.5341 117.023 69.0883 113.3Z"
        fill="#E5986D"
      />
      <path
        d="M104.456 105.854C92.5422 107.84 80.4633 97.995 75.9131 92.8242L103.835 96.5472L104.456 105.854Z"
        fill="#252A38"
      />
      <path
        d="M115.208 58.4773C118.333 78.4529 115.44 96.203 101.354 98.4063C77.1547 102.191 67.3219 86.4318 64.1974 66.4562C61.0729 46.4806 69.9592 28.501 84.0455 26.2977C98.1318 24.0944 112.084 38.5017 115.208 58.4773Z"
        fill="#E6986D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M106.02 49.0488C104.823 49.0895 103.697 49.5839 103.058 50.0169C102.49 50.4013 101.719 50.2528 101.334 49.6853C100.95 49.1178 101.098 48.3462 101.666 47.9619C102.605 47.3257 104.176 46.6281 105.936 46.5683C107.758 46.5063 109.763 47.1374 111.348 49.1291C111.774 49.6654 111.685 50.4461 111.149 50.8728C110.613 51.2995 109.832 51.2107 109.405 50.6743C108.367 49.3699 107.154 49.0102 106.02 49.0488Z"
        fill="#1B1D28"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M89.2499 55.7123C89.934 55.6552 90.544 56.0712 90.6124 56.6413L91.2348 61.8281C91.3032 62.3982 90.8041 62.9065 90.12 62.9635C89.436 63.0205 88.826 62.6046 88.7576 62.0345L88.1352 56.8477C88.0668 56.2776 88.5659 55.7693 89.2499 55.7123Z"
        fill="#1B1D28"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M106.886 54.1556C107.57 54.0986 108.18 54.5145 108.248 55.0846L108.871 60.2714C108.939 60.8415 108.44 61.3499 107.756 61.4069C107.072 61.4639 106.462 61.048 106.393 60.4779L105.771 55.2911C105.703 54.721 106.202 54.2126 106.886 54.1556Z"
        fill="#1B1D28"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M91.0948 51.1514C87.6693 50.8621 85.8366 53.059 85.376 54.0707C85.0919 54.6944 84.356 54.9698 83.7323 54.6858C83.1085 54.4018 82.8331 53.6659 83.1171 53.0422C83.8926 51.339 86.5715 48.2786 91.3037 48.6783C91.9866 48.736 92.4935 49.3364 92.4358 50.0193C92.3781 50.7022 91.7778 51.2091 91.0948 51.1514Z"
        fill="#1B1D28"
      />
      <path
        d="M76.3375 62.5321C77.459 69.7018 76.4207 76.0727 71.3648 76.8635C62.6792 78.2221 59.15 72.5656 58.0286 65.3959C56.9072 58.2262 60.0966 51.773 65.1525 50.9822C70.2084 50.1914 75.2161 55.3624 76.3375 62.5321Z"
        fill="#E6986D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M62.824 63.2012C63.5094 63.2012 64.065 63.7568 64.065 64.4421C64.065 65.275 64.2088 66.5017 64.5967 67.4715C64.9997 68.4791 65.4633 68.7856 65.9264 68.7856C66.6118 68.7856 67.1674 69.3412 67.1674 70.0265C67.1674 70.7119 66.6118 71.2675 65.9264 71.2675C63.9076 71.2675 62.82 69.7126 62.2923 68.3933C61.7495 67.0363 61.583 65.4707 61.583 64.4421C61.583 63.7568 62.1386 63.2012 62.824 63.2012Z"
        fill="#1B1D28"
      />
      <path
        d="M71.5308 55.9648C74.643 72.0444 78.0663 80.2397 91.7598 79.8248C95.4418 79.7132 98.6197 79.4456 101.356 79.0117L104.468 76.7126L108.617 77.0683C112.439 75.4414 114.529 73.2363 115.668 70.1116C115.866 69.57 116.671 69.6085 116.704 70.1841C117.209 79.1318 114.615 96.8685 102.393 99.2758C89.8071 101.755 74.3486 98.506 68.1591 82.4182C62.9724 73.6004 72.3089 75.4159 65.8252 60.8924L71.5308 55.9648Z"
        fill="#C9C9C9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M104.488 85.411C106.783 85.411 107.544 83.9836 107.544 83.4824C107.544 82.9813 106.783 81.5539 104.488 81.5539C102.193 81.5539 101.433 82.9813 101.433 83.4824C101.433 83.9836 102.193 85.411 104.488 85.411ZM104.488 87.9824C107.526 87.9824 109.988 85.9677 109.988 83.4824C109.988 80.9971 107.526 78.9824 104.488 78.9824C101.451 78.9824 98.9883 80.9971 98.9883 83.4824C98.9883 85.9677 101.451 87.9824 104.488 87.9824Z"
        fill="#1B1D28"
      />
      <path
        d="M117.254 80.5847C109.741 83.4423 105.812 79.8992 104.483 77.1318C104.286 76.7212 104.332 76.2347 104.602 75.868C107.759 71.5824 113.839 75.0138 117.649 78.2424C118.463 78.9319 118.251 80.2055 117.254 80.5847Z"
        fill="#ECECEC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M100.898 59.9048C101.52 59.7193 102.174 60.0731 102.36 60.6948C103.162 63.3844 104.208 65.4739 105.126 67.3065C105.524 68.1022 105.899 68.8495 106.218 69.5765C106.714 70.7037 107.118 71.8872 107.004 73.0407C106.88 74.3085 105.385 75.8253 104.178 76.6235C103.636 76.9812 102.907 76.8324 102.55 76.2911C102.192 75.7498 102.341 75.0209 102.882 74.6632C103.661 74.1484 104.628 73.2015 104.666 72.8107C104.716 72.3056 104.543 71.606 104.067 70.5218C103.818 69.9561 103.493 69.305 103.127 68.5725C102.184 66.687 100.972 64.2622 100.108 61.3664C99.9225 60.7446 100.276 60.0902 100.898 59.9048Z"
        fill="#1B1D28"
      />
      <path
        d="M87.1306 80.9973C97.4532 84.0751 102.902 80.3981 104.802 77.4507C105.11 76.9723 105.041 76.3489 104.643 75.9416C100.288 71.4787 91.9968 75.0801 86.7612 78.498C85.7432 79.1626 85.9655 80.6499 87.1306 80.9973Z"
        fill="#ECECEC"
      />
      <path
        d="M65.0468 61.1524C54.4287 60.0742 52.0288 48.9235 51.9896 45.2207C42.6437 38.5344 49.8516 32.841 54.6237 30.8301C54.6237 27.1785 57.5257 20.9537 74.9019 14.2109C96.6163 5.78466 112.936 9.2776 120.028 19.9163C124.697 26.9191 123.427 29.2724 121.35 32.2273C109.385 43.8823 93.0874 40.0339 86.4345 36.6528C80.3144 45.9164 71.0293 48.0748 67.1518 47.996C70.9853 51.6723 75.6649 62.2307 65.0468 61.1524Z"
        fill="#ECECEC"
      />
      <path
        d="M105.245 205.609C99.8834 209.184 92.9329 210.772 92.1385 213.354L73.0742 202.035C98.0961 191.311 101.671 202.631 105.245 205.609Z"
        fill="#E5986D"
      />
      <path
        d="M22.4355 236.587C4.56276 233.012 0.988096 213.948 0.988281 203.225L27.7975 204.416L68.3089 198.459C85.4668 197.505 93.9266 207.395 94.5223 213.948C95.1181 220.502 40.3083 240.163 22.4355 236.587Z"
        fill="#6C65D9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M87.0111 203.159C87.3776 202.629 88.1039 202.497 88.6333 202.864C90.0111 203.817 92.039 205.567 93.7347 207.774C95.4186 209.965 96.8804 212.747 96.8804 215.737C96.8804 216.381 96.3585 216.903 95.7146 216.903C95.0707 216.903 94.5487 216.381 94.5487 215.737C94.5487 213.486 93.4289 211.203 91.8857 209.194C90.3544 207.201 88.51 205.614 87.3061 204.781C86.7767 204.414 86.6446 203.688 87.0111 203.159Z"
        fill="#252A38"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M65.6972 199.699C66.3286 199.572 66.9428 199.982 67.0691 200.613C67.1954 201.245 66.7859 201.859 66.1545 201.985C58.5932 203.497 51.7929 203.648 46.8823 203.421C44.4256 203.308 42.438 203.1 41.0597 202.919C40.3704 202.829 39.8332 202.746 39.4655 202.684C39.2816 202.653 39.1401 202.628 39.0432 202.61C38.9947 202.601 38.9573 202.594 38.9314 202.589L38.9011 202.583L38.8924 202.582L38.8897 202.581C38.8893 202.581 38.8881 202.581 39.1167 201.438"
        fill="#252A38"
      />
    </svg>
  );
};

export default ChitranSvg;
